export default function () {
  return {
    errors: {},
    customToolbar: [['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['image']],
    template: {
      id: null,
      name: '',
      subject: '',
      content: '',
      smsContent: '',
      chatContent: '',
      variables: [],
    },
  }
}
